import { render, staticRenderFns } from "./p-terminal.vue?vue&type=template&id=77aa2887&"
import script from "./p-terminal.vue?vue&type=script&lang=js&"
export * from "./p-terminal.vue?vue&type=script&lang=js&"
import style0 from "./p-terminal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports